// export const DOMAIN = "http://localhost:4000"; // hoặc domain thật
export const DOMAIN = "https://api.elephant.kakiem.xyz"; // Hieu
// export const DOMAIN = "https://api.elephant.nam.kakiem.xyz"; // Nam
// export const DOMAIN = "https://api.elephant.bro.kakiem.xyz"; // anh Nam
export const DOMAIN_AUTH = `${DOMAIN}/api/auth`;
export const DOMAIN_FB = `${DOMAIN}/api/fb/`;